import { render } from "./ReviewAndSubmitComponent.vue?vue&type=template&id=033a6a9c"
import script from "./ReviewAndSubmitComponent.vue?vue&type=script&lang=js"
export * from "./ReviewAndSubmitComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__